import { useState, useRef } from "react";
import HeaderComponent from "components/card/HeaderComponent";
import { Calendar } from "antd";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";
import DailyAttendances from "./DailyAttendances";
import HeaderModal from "components/modal/HeaderModal";

const CalendarView = ({
  calendarValue,
  setCalendarValue,
  selectedDay,
  setSelectedDay,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const isNavigatingRef = useRef(false);
  return (
    <HeaderComponent
      title="Daily Attendance Overview"
      description="Click on a date to view detailed attendance"
    >
      <div className="flex justify-center items-center p-4 mx-4 border rounded-xl h-[330px] overflow-hidden">

        <Calendar
          fullscreen={false}
          value={calendarValue}
          onPanelChange={(value) => {
            setCalendarValue(value);
          }}
          onSelect={(value) => {
            if (isNavigatingRef.current) {
              isNavigatingRef.current = false; 
              return;
            }

            setCalendarValue(value); 
            setSelectedDay(value);
            setIsOpen(true);
          }}
          headerRender={({ value, onChange }) => {
            const current = value.clone();

            return (
              <div className="flex items-center justify-between mb-4 px-2 select-none">

                <button
                  onClick={() => {
                    const newVal = current.clone().subtract(1, "month").startOf("month");
                    isNavigatingRef.current = true;
                    onChange(newVal);
                    setCalendarValue(newVal);
                  }}
                  className="p-2 rounded-lg hover:bg-slate-100 transition"
                >
                  <FaChevronLeft />
                </button>
               

                <div className="font-medium">
                  {current.format("MMMM YYYY")}
                </div>

                <button
                  onClick={() => {
                    const newVal = current.clone().add(1, "month").startOf("month");
                    isNavigatingRef.current = true;
                    onChange(newVal);
                    setCalendarValue(newVal);
                  }}
                  className="p-2 rounded-lg hover:bg-slate-100 transition"
                >
                  <FaChevronRight />
                </button>

              </div>
            );
          }}
        />

        <HeaderModal
          title="Attendance Overview"
          titleClass="label-gradient emerald text-[20px] font-semibold"
          description={selectedDay?.format("dddd, MMMM D, YYYY")}
          descriptionClass="text-gray-800 dark:text-gray-100 text-base"
          open={isOpen}
          onClose={() => setIsOpen(false)}
          width="550px"
        >
          {selectedDay && (
            <DailyAttendances selectedDay={selectedDay} />
          )}
        </HeaderModal>

      </div>
    </HeaderComponent>
  );
};

export default CalendarView;